import MenuList from '../pages/Menus/MenuList';
import MenuForm from '../pages/Menus/MenuForm';
import MenuItemList from '../pages/MenuItems/MenuItemList';
import MenuItemForm from '../pages/MenuItems/MenuItemForm';
import { OWNER_ABOVE, STAFF_ABOVE } from '../constants/roles';
import RoleProtectedRoute from '../components/RoleProtectedRoute';
import type { AppRoute } from './types';

// The form screens render read-only for roles that cannot edit, so the :id routes share them.
export const menusRoutes: AppRoute[] = [
    {
        path: 'menus',
        children: [
            { index: true, element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={MenuList} /> },
            { path: 'create', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={MenuForm} /> },
            { path: 'edit/:menuId', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={MenuForm} /> },
            { path: ':id', element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={MenuForm} /> },
        ],
    },
    {
        path: 'menu-items',
        children: [
            { index: true, element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={MenuItemList} /> },
            { path: 'create', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={MenuItemForm} /> },
            { path: 'edit/:itemId', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={MenuItemForm} /> },
            { path: ':id', element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={MenuItemForm} /> },
        ],
    },
];
